{
  "eyebrow": "Confirma o teu plano",
  "title": "Revê e configura.",
  "sub": "Podes alterar o ciclo de faturação ou o plano dentro da tua linha de produto a qualquer momento no painel de administração. A mudança entre Time e Project é combinada com a nossa equipa.",
  "yourPlan": "O teu plano",
  "changePlan": "Alterar plano",
  "billing": "Ciclo de faturação",
  "billingMonthLabel": "Pagamento mensal",
  "billingMonthDesc": "Flexível. Cancela quando quiseres.",
  "billingYearLabel": "Pagamento anual",
  "billingYearDesc": "15% de desconto. Faturação uma vez por ano.",
  "addons": "Add-ons",
  "addon": {
    "ssec": "Segurança social (check-in/out@work)",
    "ssecDesc": "Apenas Bélgica — declaração Dimona automática.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "GPS em direto para os veículos da empresa. +4,80 €/veículo/mês.",
    "vehicles": "Veículos"
  },
  "users": {
    "title": "De quantos utilizadores precisas?",
    "help": "Cada pessoa que utiliza o Done-it conta como um utilizador, incluindo administradores e colaboradores.",
    "active": "utilizadores"
  },
  "estimate": "Custo mensal estimado",
  "estimateNote": "IVA não incluído. Paga pelo número de utilizadores definido aqui e pode alterá-lo mais tarde.",
  "estimateUnavailable": "Catálogo de preços indisponível. Tenta novamente para carregar os preços mais recentes."
}
